import { FETCH_IMAGES, IMAGES_FAIL, IMAGES_SUCCESS, IMAGES_SUCCESS_ACTION  } from "../actions/type";

const initialState = {
    isLoadingImages: false,
    images:null,
    error:null,
    reload:false
}

export default function (state = initialState, action){
    switch(action.type){
        case FETCH_IMAGES:
            return {...state, isLoadingImages: true, reload:false}
        case IMAGES_SUCCESS:
            return {...state, isLoadingImages: false, images: action.payload, error:null}
        case IMAGES_FAIL:
            return {...state, isLoadingImages: false, error: action.payload}
        case IMAGES_SUCCESS_ACTION:
            return {...state, isLoadingImages: false, reload:true, error:null}

        default:
            return state
        }
}

